// Static option lists for the professional inquiry contact form.
// Kept in one place so translations or branding tweaks stay easy.

export const BUDGET_OPTIONS = [
  "Under $10,000/month",
  "$10,000 - $50,000/month",
  "$50,000 - $100,000/month",
  "$100,000 - $500,000/month",
  "Over $500,000/month",
];

export const TIMELINE_OPTIONS = [
  "Immediate (Within 2 weeks)",
  "Short-term (1-3 months)",
  "Medium-term (3-6 months)",
  "Long-term (6+ months)",
  "Exploratory",
];

export const INDUSTRY_OPTIONS = [
  "Finance & Banking",
  "Healthcare & Pharmaceuticals",
  "Gambling & Gaming",
  "Cryptocurrency & Blockchain",
  "Adult Content",
  "Political Advertising",
  "E-commerce",
  "SaaS & Technology",
];

export const PLATFORM_OPTIONS = [
  "Meta (Facebook/Instagram)",
  "Google Ads",
  "TikTok",
  "LinkedIn",
  "Twitter/X",
  "Snapchat",
  "Pinterest",
  "Multiple Platforms",
];

export const PREFERRED_CONTACT_OPTIONS = ["Email", "Phone", "Both"];

export const INITIAL_CONTACT_FORM = {
  name: "",
  email: "",
  company: "",
  role: "",
  phone: "",
  preferred_contact: "Email",
  project_budget: "",
  project_timeline: "",
  industries: [],
  platforms: [],
  message: "",
};

export const slugifyOption = (value) =>
  value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-+$/g, "");
